export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14927.4ad4d2de.jpg";